import React, { PureComponent } from "react";
import { CardBody, Card, Button, ButtonGroup } from "reactstrap";
import * as todo from "../../../../../../../shared/service/usertodo";
import * as adminteam from "../../../../../../../shared/service/adminteam";
import * as validate from "../../../../../../../shared/validate";
import CreateTodo from "./create";
import TrashOutlineIcon from "mdi-react/TrashOutlineIcon";
import CheckboxMarkedCircleOutlineIcon from "mdi-react/CheckboxMarkedCircleOutlineIcon";
import CircleOutlineIcon from "mdi-react/CircleOutlineIcon";
import { Menu, MenuItem, Popover } from "@blueprintjs/core";
import UserOutlineIcon from "mdi-react/UserOutlineIcon";

class ProfileTodo extends PureComponent {
  state = {
    list: [],
    admin: [],
    loading: "Loading ...",
  };

  componentDidMount() {
    this.getList();
    this.getAdmin();
  }

  getAdmin = () => {
    adminteam.get().then((admin) => {
      this.setState({ admin: admin });
    });
  };

  getList = () => {
    todo.get(this.props.id).then((todoList) => {
      if (todoList.length > 0) {
        this.setState({ list: todoList, loading: "" });
      } else {
        this.setState({ list: todoList, loading: "No Record found" });
      }
    });
  };

  render() {
    return (
      <React.Fragment>
        <Card className="todoList">
          <CardBody className="profile__information ">
            <div className="todoListHeader">
              <div className="floatLeft">
                <h5 className="bold-text">ToDo</h5>
              </div>
              <div className="floatRight">
                <small>
                  {this.state.list.filter((obj) => obj.status === "1").length}/
                  {this.state.list.length}
                </small>
              </div>
            </div>
            <div className="clearBoth">
              <div className="task">
                <CreateTodo
                  onSubmit={(data) => {
                    if (validate.required(data.title)) {
                      todo
                        .add({ ...data, ...{ uid: this.props.id } })
                        .then((res) => this.getList());
                    }
                  }}
                />
              </div>
              <div className="vertical-scrollable-300">
                {this.state.list
                  .sort((a, b) => {
                    return a.id > b.id ? -1 : a.id < b.id ? 1 : 0;
                  })
                  .map((item, index) => (
                    <div className="task" key={index}>
                      <div className="taskTitle">
                        {item.status === "0" ? (
                          <CircleOutlineIcon
                            size="15"
                            onClick={() =>
                              todo.markDone(item).then((res) => this.getList())
                            }
                          />
                        ) : (
                          <CheckboxMarkedCircleOutlineIcon
                            size="15"
                            onClick={() =>
                              todo.markDone(item).then((res) => this.getList())
                            }
                          />
                        )}
                        {item.title}
                      </div>
                      <div xs="3" className="taskActions">
                        <div className="floatLeft">
                          <ButtonGroup size="sm">
                            <Button
                              outline
                              className="priorityRadio"
                              color="danger"
                              onClick={() => {
                                todo
                                  .setPriority(item, 1)
                                  .then((res) => this.getList());
                              }}
                              active={"1" === item.priority}
                            >
                              Low
                            </Button>
                            <Button
                              outline
                              className="priorityRadio"
                              color="primary"
                              onClick={() => {
                                todo
                                  .setPriority(item, 2)
                                  .then((res) => this.getList());
                              }}
                              active={"2" === item.priority}
                            >
                              Medium
                            </Button>
                            <Button
                              outline
                              color="success"
                              className="priorityRadio"
                              onClick={() => {
                                todo
                                  .setPriority(item, 3)
                                  .then((res) => this.getList());
                              }}
                              active={"3" === item.priority}
                            >
                              High
                            </Button>
                          </ButtonGroup>
                        </div>
                        <div className="floatRight">
                          <TrashOutlineIcon
                            className="trash"
                            size="15"
                            onClick={() =>
                              todo.remove(item).then((res) => this.getList())
                            }
                          />
                        </div>
                        <div className="floatRight">
                          {this.state.admin.length > 0 ? (
                            <div className="more-details-ellipsis-container">
                              <Popover
                                content={
                                  <Menu>
                                    {this.state.admin.map((user, index) => (
                                      <MenuItem
                                        key={index}
                                        text={user.name}
                                        onClick={() => {
                                          todo
                                            .assignUser(item, user)
                                            .then((res) => this.getList());
                                        }}
                                      />
                                    ))}
                                  </Menu>
                                }
                                position="bottom"
                              >
                                <UserOutlineIcon size="15" />
                              </Popover>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="floatRight">
                          <small>
                            <i>
                              {item.aid > 0
                                ? this.state.admin.filter(
                                    (obj) => obj.aid === item.aid
                                  ).length > 0
                                  ? this.state.admin
                                      .filter((obj) => obj.aid === item.aid)
                                      .shift()["name"]
                                  : ""
                                : ""}
                            </i>
                          </small>
                        </div>
                      </div>
                    </div>
                  ))}
                {this.state.list.length === 0 ? (
                  <React.Fragment>
                    <div className="task">
                      <div className="taskTitle">
                        <small>{this.state.loading}</small>
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default ProfileTodo;
